import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertCircle, X } from 'lucide-react';
import {
  getProfileCompletion,
  getMissingFieldLabelKey,
  getProfileTabForMissingField,
} from '../../utils/profileCompletion';
import './ProfileCompletionBanner.css';

const DISMISS_KEY = 'profile-completion-banner-dismissed';

export default function ProfileCompletionBanner({ user, addresses = [], onComplete }) {
  const { t } = useTranslation('profile');
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === '1'
  );

  const { isComplete, missing, percent } = getProfileCompletion(user, addresses);

  if (isComplete || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  const primaryMissing = missing[0];
  const completeTab = getProfileTabForMissingField(primaryMissing);
  const completeHref = `/profile?tab=${completeTab}&complete=1`;

  return (
    <div className="profile-completion-banner" role="status">
      <div className="profile-completion-banner__icon">
        <AlertCircle size={22} />
      </div>
      <div className="profile-completion-banner__body">
        <strong>{t('profileCompletion.title')}</strong>
        <p>{t('profileCompletion.message')}</p>
        <div className="profile-completion-banner__progress">
          <div
            className="profile-completion-banner__progress-fill"
            style={{ width: `${percent}%` }}
          />
        </div>
        <p className="profile-completion-banner__missing">
          {t('profileCompletion.missingIntro')}{' '}
          {missing.map((field) => t(getMissingFieldLabelKey(field))).join(', ')}
        </p>
      </div>
      <div className="profile-completion-banner__actions">
        {onComplete ? (
          <button type="button" className="profile-completion-banner__primary" onClick={onComplete}>
            {t('profileCompletion.completeNow')}
          </button>
        ) : (
          <Link to={completeHref} className="profile-completion-banner__primary">
            {t('profileCompletion.completeNow')}
          </Link>
        )}
        <button
          type="button"
          className="profile-completion-banner__later"
          onClick={handleDismiss}
        >
          {t('profileCompletion.later')}
        </button>
        <button
          type="button"
          className="profile-completion-banner__close"
          onClick={handleDismiss}
          aria-label={t('profileCompletion.close')}
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
